export const planeVariants = {
  hidden: {
    translateX: '-150%',
    translateY: 200,
    opacity: 0,
  },
  enter: {
    translateX: 0,
    translateY: 0,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
      delay: 1,
    },
    opacity: 0.5,
  },
  exit: {
    translateX: '150%',
    translateY: -300,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
      delay: 0.5,
    },
    opacity: 0,
  },
};

export const loginPlaneVariants = {
  hidden: {
    translateX: '250%',
    translateY: 100,
    opacity: 0,
  },
  enter: {
    translateX: 0,
    translateY: 0,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
      delay: 1,
    },
    opacity: 1,
  },
  exit: {
    translateX: '-250%',
    translateY: -100,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
      delay: 0.5,
    },
    opacity: 0,
  },
};

export const flightsPlaneVariants = {
  hidden: {
    translateX: '-150%',
    translateY: 100,
    opacity: 0,
  },
  enter: {
    translateX: 0,
    translateY: 0,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
      delay: 1,
    },
    opacity: 0.5,
  },
  exit: {
    translateX: '150%',
    translateY: -100,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
      delay: 0.5,
    },
    opacity: 0,
  },
};
